import { ADD_MAIN_AND_SUB_HSN, DELETE_MAIN_AND_SUB_HSN, GET_MAIN_AND_SUB_HSN, UPDATE_MAIN_AND_SUB_HSN } from "../types";
  
  // const initialState = { list: [], single: null };
  const initialState = {
    list: [],
    pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
    single: null
  };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_MAIN_AND_SUB_HSN:
        return { ...state, list: payload.data, pagination: payload.pagination };
  
      case UPDATE_MAIN_AND_SUB_HSN:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_MAIN_AND_SUB_HSN:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_MAIN_AND_SUB_HSN:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  